'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    var saveButton = document.getElementById('saveButton');
    if (saveButton) {
        saveButton.addEventListener('click', saveChangesJson);
    }

    function saveChangesDone(xhr) {
        if (!xhr || xhr.readyState !== 4) return;

        var returnObject = JSON.parse(xhr.response);
        if (returnObject.success && returnObject.result.success) {
            toastr.success(returnObject.result.message, Resx.App.SuccessfullySaved);
        } else {
            toastr.error(returnObject.result.message);
            console.error(returnObject.result.detail);
        }
    }

    function preapreDataForSave() {
        var requestBodyArray = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = document.getElementsByClassName('xml-feed-backup-settings-tab')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var tab = _step.value;

                requestBodyArray.push({
                    Id: tab.querySelector('input#Id').value,
                    DisableByNextGeneration: tab.querySelector('input[type=checkbox].disable-by-next-generation').checked,
                    UseBackup: tab.querySelector('input[type=checkbox].use-backup').checked,
                    SelectedBackup: tab.querySelector('select.backup-list').value
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return requestBodyArray;
    }

    function saveChangesJson() {
        var url = 'SaveChangesJson';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
        xhr.onreadystatechange = function () {
            saveChangesDone(xhr);
        };

        var body = JSON.stringify({ xmlSettingsArray: preapreDataForSave() });
        xhr.send(body);
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/xmlFileBackupSettings.js
// module id = 461
// module chunks = 0